import { render, staticRenderFns } from "./MobileContainer.vue?vue&type=template&id=24324e2a"
import script from "./MobileContainer.ts?vue&type=script&lang=ts&external"
export * from "./MobileContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports